import type { BusinessQuery } from '@/modules/dashboard/dashboardTypes';
import { getBusinessesList } from '@/services/dashboardService';
import { useQuery } from '@tanstack/react-query';

export const useQueryBusiness = (filters: BusinessQuery) => {
	return useQuery({
		queryKey: ['list-details-business-data', ...Object.entries(filters)],
		queryFn: () =>
			getBusinessesList({
				filters: {
					...filters,
					count: true
				}
			}),
		refetchOnWindowFocus: false
	});
};
